import { withField } from '../with-field';

import { FuelCheckbox } from '@frete.com/fuel-react';
import { FC } from 'react';

import * as Styled from './styled';
import { CheckboxProps } from './types';

export const Checkbox: FC<CheckboxProps> = ({ label, className, name, value, onChange, onClick, ...props }) => (
  <Styled.Container
    className={className}
    onClick={() => {
      onClick?.();
      onChange?.({ target: { value: !value, name } });
    }}
  >
    <Styled.Wrapper>
      <FuelCheckbox {...props} name={name} checked={value as boolean} />
    </Styled.Wrapper>
    {label}
  </Styled.Container>
);

export const ControlledCheckbox = withField(Checkbox);
